/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/Auth";
import MainLayout from "@/layouts/Main";
import store from "@/store";
import _ from "lodash";
import { PRIMARY_SCHOOL_TYPES, COLLEGE_SCHOOL_TYPES } from "@/config/Constants";
Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history', // Keep hash mode (default)
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: () => {
        if (store.state.user.authorized && store.state.user.access) {
          const access = store.state.user.access;

          if (access.all === true || access.home === true) {
            return "/elevesliste";
          } else {
            let firstAcess = {};
            let path = "";

            for (let key of Object.keys(access)) {
              if (access[key] === true || (Array.isArray(access[key]) && access[key].length > 0)) {
                firstAcess = {
                  key: key,
                  role: Array.isArray(access[key])
                    ? access[key].filter((e) => e !== "all")
                    : access[key],
                };
                break;
              }
            }
            if (!firstAcess.key) {
              return "/profile";
            }

            let routes = router.options.routes[0].children;
            const foundRoute = routes.find(
              (e) =>
                (e.meta.accessGroup == firstAcess.key &&
                  Array.isArray(e.meta.roles) &&
                  e.meta.roles.includes(firstAcess.role[0])) ||
                (e.meta.accessGroup == firstAcess.key && firstAcess.role === true)
            );

            path = foundRoute ? foundRoute.path : "/profile";
            return path;
          }
        }
        // Fallback to profile if not authorized or no access data
        return "/profile";
      },
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: "/calender",
          meta: {
            title: "Calender",
            roles: ["calendar"],
            accessGroup: "calendar",
            accessPack: "calender",
          },
          component: () => import("./views/calender/index"),
        },
        {
          path: "/chat",
          meta: {
            title: "chat",
            roles: ["chat"],
            accessGroup: "chat",
            accessPack: "chat",
          },
          component: () => import("./views/chat/index"),
        },
        {
          path: "/ptchat",
          meta: {
            title: "Chat enseignant parent",
            roles: ["chat"],
            accessGroup: "chat",
            accessPack: "ptchat",
          },
          component: () => import("./views/ptchat/index"),
        },
        {
          path: "/degital_library",
          meta: {
            title: "Bibliothèque numérique",
            roles: ["all", "digitalLibrary"],
            accessGroup: "digitalLibrary",
            accessPack: "digitalLibrary",
          },
          component: () => import("./views/degital_library/index"),
        },
        {
          path: "/degital_library/document/:id",
          meta: {
            title: "Bibliothèque numérique",
            roles: ["all", "digitalLibrary"],
            accessGroup: "digitalLibrary",
            accessPack: "digitalLibrary",
          },
          component: () =>
            import("./views/degital_library/components/DocumentDetails.vue"),
        },
        //marketPlace
        {
          path: "/marketPlace",
          meta: {
            title: "Boutique scolaire",
            roles: ["all", "marketPlace"],
            accessGroup: "marketPlace",
            accessPack: "marketPlace",
          },
          component: () => import("./views/marketPlace/index"),
        },
        {
          path: "/product/:id",
          meta: {
            title: "ProductDetails",
            roles: ["all", "marketPlace"],
            accessGroup: "marketPlace",
            accessPack: "marketPlace",
          },
          component: () =>
            import("./views/marketPlace/components/productDetails"),
        },
        {
          path: "/command/:id",
          meta: {
            title: "CommandDetails",
            roles: ["all", "marketPlace"],
            accessGroup: "marketPlace",
            accessPack: "marketPlace",
          },
          component: () =>
            import("./views/marketPlace/components/commandDetails.vue"),
        },

        {
          path: "/teacherAvailability",
          meta: {
            title: "Teacher's availability",
            roles: ["all", "teacher_dispo"],
            accessGroup: "emplois",
            accessPack: "teacherAvailability",
          },
          component: () => import("./views/scolarite/teacherAvailability"),
        },
        /* {
           path: "/smart-schedule",
           meta: {
             title: "Smart schedule table",
             roles: ["all", "smart_schedules"],
             accessGroup: "emplois",
             accessPack: "smartSchedule",
           },
           component: () => import("./views/scolarite/smartSchedule"),
         },
         {
           path: "/smart-schedule/:schedParamId",
           meta: {
             title: "Smart schedule",
             roles: ["all", "smart_schedules"],
             accessGroup: "emplois",
             accessPack: "smartSchedule",
           },
           component: () =>
             import("./views/scolarite/smartSchedule/viewSchedule"),
         },*/
        // Dashboards
        {
          path: "/autorisation",
          meta: {
            title: "autorisation",
            roles: ["autorisation"],
            accessGroup: "adminstration",
            accessPack: "adminstration",
          },
          component: () => import("./views/administration/autorisation"),
        },
        {
          path: "/utilisateur",
          meta: {
            title: "utilisateur",
            roles: ["utilisateur"],
            accessGroup: "adminstration",
            accessPack: "adminstration",
          },
          component: () => import("./views/administration/utilisateur"),
        },
        {
          name: "homePage",
          path: "/accueil",
          meta: {
            title: "Accueil",
            roles: ["statstiqueGeneral"],
            accessGroup: "home",
            accessPack: "statstiqueGeneral",
          },
          component: () => import("./views/accueil"),
        },
        {
          path: "/financial-statistics",
          meta: {
            title: "Statistiques financières",
            roles: ["financialStats"],
            accessGroup: "home",
            accessPack: "financialStats",
          },
          component: () => import("./views/financialStats"),
        },
        {
          path: "/etablissement",
          meta: {
            title: "Paramétrage - Etablissement",
            roles: ["all", "etablissement"],
            accessGroup: "parametrage",
            accessPack: "statstiqueGeneral",
          },
          component: () => import("./views/parametrage/etablissement"),
        },
        {
          path: "/comptabilite",
          meta: {
            title: "Paramétrage - Comptabilité",
            roles: ["all", "comptabilite"],
            accessGroup: "parametrage",
            accessPack: "parametrageComptabilite",
          },
          component: () => import("./views/parametrage/comptabilite"),
        },
        {
          path: "/scolarite",
          meta: {
            title: "Paramétrage - Scolarité",
            roles: ["all", "scolarite"],
            accessGroup: "parametrage",
            accessPack: "parametrageScolarite",
          },
          component: () => import("./views/parametrage/scolarite"),
        },
        {
          path: "/smartscheduleParams",
          meta: {
            title: "Paramétrage - smart schedule",
            roles: ["all", "smart_schedule"],
            accessGroup: "parametrage",
            accessPack: "smartSchedule",
          },
          component: () => import("./views/parametrage/smartSchedule"),
        },
        {
          path: "/bulletin",
          meta: {
            title: "Paramétrage - Bulletin",
            roles: ["all", "bulletin"],
            accessGroup: "parametrage",
            accessPack: "bulletin",
          },
          component: () => import("./views/parametrage/bulletin"),
        },
        {
          path: "/sms-settings",
          meta: {
            title: "Paramètres de SMS automatiques",
            roles: ["all", "sms"],
            accessGroup: "parametrage",
            accessPack: "sms",
          },
          component: () => import("./views/parametrage/sms"),
        },
        {
          path: "/etatPaiementActivite",
          meta: {
            title: "etatPaiementActivite",
            roles: ["etat_paiement"],
            accessGroup: "activite",
            accessPack: "activites",
          },
          component: () => import("./views/activites/etatPaiement"),
        },
        {
          path: "/cantine",
          meta: {
            title: "cantine",
            roles: ["cantine"],
            accessGroup: "activite",
            accessPack: "cantine",
          },
          component: () => import("./views/cantine"),
        },
        {
          path: "/PaiementActivite/:activityId",
          meta: {
            title: "etatPaiementActivite",
            roles: ["etat_paiement"],
            accessGroup: "activite",
            accessPack: "activites",
          },
          component: () =>
            import("./views/activites/etatPaiement/activityPayment.vue"),
          props: true,
        },
        {
          path: "/inscriptionActivites",
          meta: {
            title: "inscriptionActivites",
            roles: ["inscription"],
            accessGroup: "activite",
            accessPack: "activites",
          },
          component: () => import("./views/activites/inscriptionActivites"),
        },
        {
          path: "/emploiActivites",
          meta: {
            title: "emploiActivites",
            roles: ["inscription"],
            accessGroup: "activite",
            accessPack: "activites",
          },
          component: () => import("./views/activites/emploiActivites"),
        },
        {
          path: "/assiduiteActivites",
          meta: {
            title: "assiduiteActivites",
            roles: ["inscription"],
            accessGroup: "activite",
            accessPack: "activites",
          },
          component: () => import("./views/activites/assiduiteActivites"),
        },
        {
          path: "/inscriptionScolarite",
          meta: {
            title: "inscriptionScolarité",
            roles: ["inscription"],
            accessGroup: "scolarite",
            accessPack: "scolarite",
          },
          component: () => import("./views/scolarite/inscriptionScolarite"),
        },
        {
          path: "/inscriptionScolarite/promotion",
          meta: {
            title: "inscriptionScolarité",
            roles: ["inscription"],
            accessGroup: "scolarite",
            accessPack: "scolarite",
          },
          component: () =>
            import("./views/scolarite/inscriptionScolarite/promotion.vue"),
        },
        {
          path: "/listePunitions",
          meta: {
            title: "listePunitions",
            roles: ["punition"],
            accessGroup: "scolarite",
            accessPack: "punishments",
          },
          component: () => import("./views/scolarite/listePunitions"),
        },
        {
          path: "/pickup",
          meta: {
            title: "pickup",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
          },
          component: () => import("./views/scolarite/pickup"),
        },
        {
          path: "/schedule",
          meta: {
            title: "Student schedule",
            roles: ["eleves"],
            accessGroup: "emplois",
            accessPack: "emplois",
          },
          component: () => import("./views/scolarite/schedule"),
        },
        {
          path: "/teacherschedule",
          meta: {
            title: "Teacher schedule",
            roles: ["enseignant"],
            accessGroup: "emplois",
            accessPack: "emplois",
          },
          component: () => import("./views/scolarite/teacherSchedule"),
        },
        {
          path: "/teacherAccess",
          meta: {
            title: "Acceés enseignants",
            roles: ["enseignant"],
            accessGroup: "emplois",
            accessPack: "personnel",
          },
          component: () => import("./views/scolarite/teacherAccess"),
        },

        {
          path: "/bulletin/notemodule",
          meta: {
            title: "Bulletin pédagogique - Notes par matière",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletin/marksModule"),
        },
        {
          path: "/bulletin/notemodulecomplet",
          meta: {
            title: "Bulletin pédagogique - Note par module",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletin/marksModuleComplet"),
        },
        {
          path: "/bulletin/noteeleve",
          meta: {
            title: "Bulletin pédagogique - Notes par élève",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletin/studentMarks"),
        },
        // bulletin v2
        {
          path: "/bulletinV2/bulletinPedagogique",
          meta: {
            title: "Bulletin pédagogique",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinv2"),
          props: { type: "MP" },
        },
        {
          path: "/bulletinV2/bulletinPilote",
          meta: {
            title: "Bulletin pilote",
            roles: ["bulletin", "all", "pilote"],
            accessGroup: "bulletin",
            accessPack: "bulletinPilote",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinv2"),
          props: { type: "MT" },
        },
        {
          path: "/bulletinV2/bulletinVerySpecifique",
          meta: {
            title: "Bulletin specifique",
            roles: ["bulletin", "all", "specific"],
            accessGroup: "bulletin",
            accessPack: "bulletinSpecific",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinv2"),
          props: { type: "MS" },
        },
        // end bulletin v2
        {
          path: "/bulletin/appreciationAdmin",
          meta: {
            title: "Appréciation administrative",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletin/appreciationAdmin"),
        },
        {
          path: "/bulletin/certification",
          meta: {
            title: "Certification Pédagogique",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletin/certification"),
        },
        {
          path: "/specbulletin/notemodule",
          meta: {
            title: "Bulletin pilote - Notes par matière",
            roles: ["bulletin", "all", "pilote"],
            accessGroup: "bulletin",
            accessPack: "bulletinPilote",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinSpecifique/marksModule"),
        },
        {
          path: "/specbulletin/notemodulecomplet",
          meta: {
            title: "Bulletin pilote - Notes par module",
            roles: ["bulletin", "all", "pilote"],
            accessGroup: "bulletin",
            accessPack: "bulletinPilote",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () =>
            import("./views/bulletinSpecifique/marksModuleComplet"),
        },
        {
          path: "/specbulletin/noteeleve",
          meta: {
            title: "Bulletin pilote - Notes par élève",
            roles: ["bulletin", "all", "pilote"],
            accessGroup: "bulletin",
            accessPack: "bulletinPilote",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinSpecifique/studentMarks"),
        },
        {
          path: "/veryspecbulletin/notematiere",
          meta: {
            title: "Bulletin specifique - Notes par matière",
            roles: ["bulletin", "all", "specific"],
            accessGroup: "bulletin",
            accessPack: "bulletinSpecific",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () =>
            import("./views/bulletinVerySpecific/marksParMatiere"),
        },
        {
          path: "/veryspecbulletin/notemodule",
          meta: {
            title: "Bulletin specifique - Notes par module",
            roles: ["bulletin", "all", "specific"],
            accessGroup: "bulletin",
            accessPack: "bulletinSpecific",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () =>
            import("./views/bulletinVerySpecific/marksModuleComplet"),
        },
        {
          path: "/veryspecbulletin/noteeleve",
          meta: {
            title: "Bulletin specifique - Notes par élève",
            roles: ["bulletin", "all", "specific"],
            accessGroup: "bulletin",
            accessPack: "bulletinSpecific",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinVerySpecific/studentMarks"),
        },
        {
          path: "/bulletinStatistique",
          meta: {
            title: "Bulletin statistique",
            roles: ["bulletin", "all", "statistique"],
            accessGroup: "bulletin",
            accessPack: "bulletinStatistique",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinStatistique"),
        },
        {
          path: "/bulletinStatistiqueV2",
          meta: {
            title: "Bulletin statistique",
            roles: ["bulletin", "all", "statistique"],
            accessGroup: "bulletin",
            accessPack: "bulletinStatistique",
            schoolTypes: PRIMARY_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinStatistiqueV2"),
        },
        //bulletin college
        {
          path: "/bulletin/college/noteeleve",
          meta: {
            title: "Bulletin pédagogique collège",
            roles: ["bulletin", "all", "pedagogic"],
            accessGroup: "bulletin",
            accessPack: "bulletin",
            schoolTypes: COLLEGE_SCHOOL_TYPES,
          },
          component: () => import("./views/bulletinCollege/studentMarks/index.vue"),
        },
        {
          path: "/connected",
          meta: {
            title: "Utilisateurs connectés",
            roles: ["all", "usersStats"],
            accessGroup: "home",
            accessPack: "usersStats",
          },
          component: () => import("./views/UsersStats"),
        },
        /*         {
          path: "/powerbi",
          meta: {
            title: "PowerBI",
            roles: ["all", "statistique"],
            accessGroup: "home",
          },
          component: () => import("./views/powerbi"),
        }, */
        {
          path: "/etatDesImpayes",
          meta: {
            title: "etatDesImpayés",
            roles: ["etat_paiement"],
            accessGroup: "scolarite",
            accessPack: "scolarite",
          },
          component: () => import("./views/scolarite/etatDesImpayes"),
        },
        {
          path: "/etatImpayesActivites",
          meta: {
            title: "etatImpayesActivites",
            roles: ["etat_impayesA"],
            accessGroup: "declaration",
            accessPack: "declaration",
          },
          component: () => import("./views/declarations/etatImpayesActivites"),
        },
        {
          path: "/etatImpayesScolarite",
          meta: {
            title: "etatImpayesScolarite",
            roles: ["etat_impayesS"],
            accessGroup: "declaration",
            accessPack: "declaration",
          },
          component: () => import("./views/declarations/etatImpayesScolarite"),
        },
        {
          path: "/declarationTVA",
          meta: {
            title: "declarationTVA",
            roles: ["declarationTVA"],
            accessGroup: "declaration",
            accessPack: "declaration",
          },
          component: () => import("./views/declarations/declarationTVA"),
        },
        {
          path: "/chiffreAffaire",
          meta: {
            title: "chiffreAffaire",
            roles: ["chiffre_affaire"],
            accessGroup: "declaration",
            accessPack: "declaration",
          },
          component: () => import("./views/declarations/chiffreAffaire"),
        },
        {
          path: "/chiffreAffaireScolarite",
          meta: {
            title: "chiffreAffaireScolarite",
            roles: ["chiffre_affaireS"],
            accessGroup: "declaration",
            accessPack: "declaration",
          },
          component: () =>
            import("./views/declarations/chiffreAffaireScolarite"),
        },
        {
          path: "/listePersonnel",
          meta: {
            title: "listePersonnel",
            roles: ["personnel"],
            accessGroup: "personnel",
            accessPack: "personnel",
          },
          component: () => import("./views/personnel/listePersonnel"),
        },
        {
          path: "/listeEnseignant",
          meta: {
            title: "listeEnseignants",
            roles: ["enseignant"],
            accessGroup: "personnel",
            accessPack: "personnel",
          },
          component: () => import("./views/personnel/listeEnseignant"),
        },
        {
          path: "/etatDePaiement",
          meta: {
            title: "etatDePaiement",
            roles: ["etat_paiement"],
            accessGroup: "personnel",
            accessPack: "personnel",
          },
          component: () => import("./views/personnel/etatDePaiement"),
        },
        {
          path: "/teacherAttendance",
          meta: {
            title: "teacherAttendance",
            roles: ["enseignant", "personnel"],
            accessGroup: "personnel",
            accessPack: "personnel",
          },
          component: () => import("./views/personnel/teacherAttendance"),
        },
        // Tables
        {
          path: "/elevesliste",
          meta: {
            title: "Liste des élèves",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "studentList",
          },
          component: () => import("./views/eleves"),
        },
        {
          path: "/new-payment",
          meta: {
            title: "Nouveaux paiement",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "studentList",
          },
          component: () => import("./views/eleves/newPayment/index.vue"),
        },
        {
          path: "/archive_elevesliste",
          meta: {
            title: "Liste des élèves archivée",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "studentList",
          },
          component: () => import("./views/eleves/archive"),
        },

        {
          path: "/preinscription",
          meta: {
            title: "Pré-inscription",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "preInscription",
          },
          component: () => import("./views/preinscription"),
        },
        //xlsx uploader
        {
          path: "/uploadeleves",
          meta: {
            title: "Upload - Liste des élèves",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "studentList",
          },
          component: () => import("./views/eleves/xlsxUploader"),
        },
        {
          path: "/sms/envoyer",
          meta: {
            title: "Envoyer SMS",
            roles: ["all", "send"],
            accessGroup: "sms",
            accessPack: "sms",
          },
          component: () => import("./views/sms/send"),
        },
        {
          path: "/sms/envoyerClasse",
          meta: {
            title: "Envoyer par classe",
            roles: ["all", "send"],
            accessGroup: "sms",
            accessPack: "sms",
          },
          component: () => import("./views/sms/sendClass"),
        },
        {
          path: "/sms/envoyerLogin",
          meta: {
            title: "Envoyer Logins",
            roles: ["all", "send"],
            accessGroup: "sms",
            accessPack: "sms",
          },
          component: () => import("./views/sms/sendParentLogin"),
        },
        {
          path: "/sms/historique",
          meta: {
            title: "Historique SMS",
            roles: ["all", "history"],
            accessGroup: "sms",
            accessPack: "sms",
          },
          component: () => import("./views/sms/history"),
        },
        {
          path: "/eleve/:studentId",
          meta: {
            title: "Profile d'élève",
            roles: ["liste_eleves"],
            accessGroup: "liste_eleves",
            accessPack: "studentList",
          },
          component: () => import("./views/eleves/profile"),
          props: true,
        },
        {
          path: "/inscriptionScolarite/:classId",
          meta: {
            title: "inscriptionScolarite",
            roles: ["inscription"],
            accessGroup: "scolarite",
            accessPack: "scolarite",
          },
          component: () =>
            import("./views/scolarite/inscriptionScolarite/classInscri.vue"),
          props: true,
        },

        {
          path: "/manageCaisses",
          meta: {
            title: "listeReglementAnnulé",
            roles: ["caisse_management"],
            accessGroup: "tresorerie",
            accessPack: "tresorerie",
          },
          component: () => import("./views/compV3/caisse/manageCaisses"),
        },
        {
          path: "/caisseProfile/:id",
          meta: {
            title: "Caisse Profile",
            roles: ["caisse_management"],
            accessGroup: "tresorerie",
            accessPack: "tresorerie",
          },
          component: () => import("./views/compV3/caisse/CaisseProfile"),
          props: true,
        },
        {
          path: "/myCaisse",
          meta: {
            title: "Ma caisse",
            roles: ["my_caisse"],
            accessGroup: "tresorerie",
            accessPack: "tresorerie",
          },
          component: () =>
            import(
              /* webpackChunkName: "my-caisse" */ "./views/compV3/caisse/myCaisse.vue"
            ),
          props: true,
        },
        {
          path: "/chequeEtTraite",
          meta: {
            title: "Cheque et traite",
            roles: ["stat_tab", "borderaux_tab", "cheque_traite_tab"],
            accessGroup: "tresorerie",
            accessPack: "tresorerie",
          },
          component: () => import("./views/compV3/tresorerie/chequesTraites"),
          props: true,
        },
        {
          path: "/reglementsAnnules",
          meta: {
            title: "Réglements annulés",
            roles: ["reglement_annule"],
            accessGroup: "tresorerie",
            accessPack: "tresorerie",
          },
          component: () => import("./views/compV3/tresorerie/listeReglementAnnule"),
          props: true,
        },
        {
          path: "/encaissement/etatDesRecettes",
          meta: {
            title: "Encaissement - État des recettes",
            roles: ["etat_recettes"],
            accessGroup: "encaissement",
            accessPack: "encaissement",
          },
          component: () => import("./views/compV3/encaissement/etatDesRecettes"),
        },
        {
          path: "/caisseavance",
          meta: {
            title: "Caisse avance",
            roles: ["etat_recettes"],
            accessGroup: "encaissement",
            accessPack: "encaissement",
          },
          component: () => import("./views/comptabilite/avance"),
        },
        {
          path: "/encaissement/etatDesImpayes",
          meta: {
            title: "Encaissement - État des impayés",
            roles: ["etat_impayes"],
            accessGroup: "encaissement",
            accessPack: "encaissement",
          },
          component: () => import("./views/compV3/encaissement/etatDesImpayes"),
        },
        {
          path: "/decaissement/depenses-v3",
          redirect: "/decaissement/nouvelle-depense",
        },
        {
          path: "/decaissement/nouvelle-depense",
          meta: {
            title: "Nouvelle dépense",
            roles: ["nouvelle_depense", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement"),
        },
        {
          path: "/decaissement/fournisseurs",
          meta: {
            title: "Fournisseurs",
            roles: ["fournisseurs", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/suppliers"),
        },
        {
          path: "/decaissement/fournisseur/:providerId",
          meta: {
            title: "Fournisseur",
            roles: ["fournisseurs", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/suppliers/profile"),
        },
        {
          path: "/decaissement/factures",
          redirect: (to) => ({
            path: "/decaissement/fournisseurs",
            query: { ...to.query, tab: "invoices" },
          }),
        },
        {
          path: "/decaissement/saisie-paiement",
          meta: {
            title: "Saisie de paiement",
            roles: ["saisie_paiement", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/paymentEntry"),
        },
        {
          path: "/decaissement/historique-paiements",
          meta: {
            title: "Historique des paiements",
            roles: ["historique_paiements", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/paymentHistory"),
        },
        {
          path: "/decaissement/validation-reception",
          meta: {
            title: "Validation de réception",
            roles: ["validation_reception", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/encaissementValidation"),
        },
        {
          path: "/decaissement/reconciliation",
          meta: {
            title: "Réconciliation",
            roles: ["reconciliation", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/reconciliation"),
        },
        {
          path: "/decaissement/avoir-fournisseur",
          meta: {
            title: "Avoir fournisseur",
            roles: ["avoir_fournisseur", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/avoir"),
        },
        {
          path: "/decaissement/dettes",
          meta: {
            title: "Gestion des dettes",
            roles: ["dettes", "depense"],
            accessGroup: "decaissement",
            accessPack: "decaissement",
          },
          component: () => import("./views/compV3/decaissement/debts"),
        },
        {
          path: "/actuality",
          meta: {
            title: "Actualité",
            roles: ["actualite"],
            accessGroup: "actualite",
            accessPack: "news",
          },
          component: () => import("./views/actuality"),
        },
        {
          path: "/actuality/:id",
          meta: {
            title: "Actualité détails",
            roles: ["actualite"],
            accessGroup: "actualite",
            accessPack: "news",
          },
          component: () => import("./views/actuality/singleActuality"),
        },
        {
          path: "/activity-club/:id",
          meta: {
            title: "Activity club",
            roles: ["actualite"],
            accessGroup: "actualite",
            accessPack: "news",
          },
          component: () => import("./views/actuality/activityClub/singleClubPost"),
        },
        {
          path: "/attendance",
          meta: {
            title: "Assiduité",
            roles: ["assiduite"],
            accessGroup: "assiduite",
            accessPack: "attendance",
          },
          component: () => import("./views/attendance"),
        },
        {
          path: "/profile",
          name: "profile",
          meta: {
            title: "Mon Profile",
            roles: true,
          },
          component: () =>
            import(
              "./components/cleanui/layout/Topbar/UserMenu/components/profile"
            ),
        },
        // Charts
        {
          path: "/notifications",
          meta: {
            title: "Notifications",
            roles: ["notifications"],
            accessGroup: "notifications",
          },
          component: () => import("@/views/notifications"),
        },
      ],
    },

    // System Pages
    {
      path: "/auth",
      component: AuthLayout,
      redirect: "auth/login",
      children: [
        {
          path: "/auth/404",
          meta: {
            title: "Error 404",
          },
          component: () => import("./views/auth/404"),
        },
        {
          path: "/auth/500",
          meta: {
            title: "Error 500",
          },
          component: () => import("./views/auth/500"),
        },
        {
          path: "/auth/login",
          meta: {
            title: "Sign In",
          },
          component: () => import("./views/auth/login"),
          beforeEnter: (to, from, next) => {
            if (store.state.user.authorized) next({ name: "homePage" });
            else next();
          },
        },
        {
          path: "/auth/register",
          meta: {
            title: "Sign Up",
          },
          component: () => import("./views/auth/register"),
        },
        {
          path: "/auth/forgot-password",
          meta: {
            title: "Forgot Password",
          },
          component: () => import("./views/auth/forgot-password"),
        },
        {
          path: "/auth/lockscreen",
          meta: {
            title: "Lockscreen",
          },
          component: () => import("./views/auth/lockscreen"),
        },
      ],
    },

    // Redirect to 404
    {
      path: "*",
      redirect: "auth/404",
      hidden: true,
    },
    {
      path: "/sso-login",
      meta: {
        title: "SSO Login",
        authRequired: false,
      },
      component: () => import("./views/auth/ssoLogin"),
    },
  ],
});
const verifyPackAccess = (accessPack) => {
  if (!accessPack) return true;

  // Ensure we have the necessary state before checking
  if (!store.state.user.building || !Array.isArray(store.state.user.building) || store.state.user.building.length === 0) {
    return false;
  }

  if (!store.state.settings.activeBuilding) {
    return false;
  }

  const schoolDetails =
    store.state.user.building.find(
      (el) => el.dbName == store.state.settings.activeBuilding
    ) || {};

  return schoolDetails.pack?.access?.edManager?.[accessPack] === "v";
};

const verifySchoolType = (meta) => {
  if (!meta.schoolTypes) return true;
  let schoolDetails =
    store.state.user.building.find(
      (el) => el.dbName == store.state.settings.activeBuilding
    ) || {};
  const buildingType = schoolDetails.type;
  if (!buildingType) return false;
  const types = Array.isArray(buildingType) ? buildingType : [buildingType];
  return types.some((type) => meta.schoolTypes.includes(type));
};

const verifyRoleAccess = (routeMeta) => {
  const { roles, accessGroup } = routeMeta;
  const userAccess = store.state.user.access;

  // Ensure access data exists
  if (!userAccess || typeof userAccess !== "object") {
    return false;
  }

  if (userAccess.all) return true;

  if (roles === true) return true;

  if (Array.isArray(roles)) {
    const groupAccess = userAccess[accessGroup];
    if (accessGroup === "decaissement" && Array.isArray(groupAccess)) {
      if (groupAccess.includes("depense") || groupAccess.includes("all")) {
        return true;
      }
      return roles.some((role) => groupAccess.includes(role));
    }
    return (
      groupAccess === true ||
      (Array.isArray(groupAccess) && roles.some((role) => groupAccess.includes(role)))
    );
  }

  return false;
};

router.beforeEach((to, from, next) => {
  if (to.path === "/sso-login" || to.path === "/#/sso-login") {
    return next();
  }

  const requiresAuth = to.matched.some((record) => record.meta.authRequired);
  if (!requiresAuth) {
    return next();
  }

  if (!store.state.user.authorized) {
    return next({
      path: "/auth/login",
      query: { redirect: to.fullPath },
    });
  }

  // If coming from login page and user is just authorized, allow navigation
  // The building config might still be setting up
  const isComingFromLogin = from.path === "/auth/login" || from.path === "/#/auth/login";
  if (isComingFromLogin && !store.state.settings.activeBuilding) {
    // Allow navigation - building config is being set up
    return next();
  }

  // Only check pack access and school type if building is configured
  if (store.state.settings.activeBuilding) {
    if (!verifyPackAccess(to.meta.accessPack) || !verifySchoolType(to.meta)) {
      return next({
        path: "/auth/404",
        query: { redirect: to.fullPath },
      });
    }
  }

  if (!verifyRoleAccess(to.meta)) {
    return next({
      path: "/auth/500",
      query: { redirect: to.fullPath },
    });
  }

  next();
});

export default router;
